import { Controller } from '@hotwired/stimulus'
import { BarcodeDetector } from 'barcode-detector/pure'

export default class extends Controller {
  static targets = ['tabCodeField', 'video']
  static values = {
    facingMode: { type: String, default: 'user' }
  }

  connect () {
    this.#startScanning()
  }

  disconnect () {
    this.#stopScanning()
  }

  async #startScanning () {
    this.detector = new BarcodeDetector({
      formats: ['qr_code', 'code_128', 'code_39', 'ean_13', 'ean_8']
    })

    try {
      this.stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: this.facingModeValue }
      })

      const video = this.videoTarget
      video.srcObject = this.stream
      await video.play()

      this.#detectLoop(video)
    } catch (err) {
      console.warn('Camera access error:', err)
    }
  }

  async #detectLoop (video) {
    if (!this.stream) return

    try {
      const barcodes = await this.detector.detect(video)
      if (barcodes.length > 0) {
        this.tabCodeFieldTarget.value = barcodes[0].rawValue
        this.element.requestSubmit()
        this.#stopScanning()
        return
      }
    } catch (err) {
      // frame not ready yet, continue
    }

    this.animFrameId = requestAnimationFrame(() => this.#detectLoop(video))
  }

  #stopScanning () {
    if (this.animFrameId) cancelAnimationFrame(this.animFrameId)
    if (this.stream) {
      this.stream.getTracks().forEach(t => t.stop())
      this.stream = null
    }
  }
}
